import SurveyForm from "./SurveyForm";
const Edit = (props) => <SurveyForm {...props} />;

export default Edit